import ZaiaModalResponseContent from "./ZaiaModalResponseContent";

export default ZaiaModalResponseContent;